export const PATH_HINT_VIDEO = `/api/v2/hintVideo`;
